import { render, staticRenderFns } from "./makePaymentModal.vue?vue&type=template&id=47ddd1cf&scoped=true&lang=pug"
import script from "./makePaymentModal.vue?vue&type=script&lang=js"
export * from "./makePaymentModal.vue?vue&type=script&lang=js"
import style0 from "./makePaymentModal.vue?vue&type=style&index=0&id=47ddd1cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ddd1cf",
  null
  
)

export default component.exports